<div *ngIf="show" class="{{ type }} kl-alert">
  <div class="table">
    <div class="icon"><i class="fa {{ iconClass(type) }}"></i></div>
    <div class="message">
      <span>{{ message | translate }}</span>
    </div>
    <a class="close" (click)="removeAlert()">&times;</a>
  </div>
</div>
